'use client'

import { ErrorLayout } from '~/components/error/error-layout.tsx'

export default function Page() {
  return <ErrorLayout code={404} />
}
